import { motion } from 'framer-motion';
import { Award, Users, Building, TrendingUp } from 'lucide-react';

const stats = [
  { icon: Building, value: '50+', label: 'Properties Listed' },
  { icon: Users, value: '20+', label: 'Happy Clients' },
  { icon: Award, value: '5+', label: 'Years Experience' },
  { icon: TrendingUp, value: '98%', label: 'Client Satisfaction' }
];

export const WhyChooseUs = () => {
  return (
    <section className="py-24 md:py-32 bg-background-secondary" data-testid="why-choose-us-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="text-center mb-16">
          <p className="text-xs md:text-sm uppercase tracking-widest text-brand-green mb-4" data-testid="why-choose-us-subtitle">Trust & Excellence</p>
          <h2 className="text-4xl md:text-5xl font-heading font-light text-text-primary" data-testid="why-choose-us-title">Why Choose Us</h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-testid="stats-list">
          {stats.map((stat, index) => (
            <motion.div key={stat.label} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: index * 0.1 }} className="text-center" data-testid={`stat-${index}`}>
              <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-brand-green/10 border border-brand-green/20 hover:border-brand-green transition-colors duration-300">
                <stat.icon className="text-brand-green" size={28} />
              </div>
              <h3 className="text-4xl md:text-5xl font-heading font-light text-text-primary mb-2">{stat.value}</h3>
              <p className="text-sm text-text-secondary">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
